<template>
<div :class="classes" @click="onClick">
	<slot name="text" v-if="text || $slots.text">
		<span :title="text">{{ text }}</span>
	</slot>
</div>
</template>

<script>

export default {
	name: "NavSidebarItem",
	props: {
		className: {
			type: String,
			default: "",
		},
		text: {
			type: String,
			default: "",
		},
		isSelected: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		classes() {
			return {
				"nav-sidebar-item": true,
				"nav-sidebar-item--selected": this.isSelected,
				[ this.className ]: !!this.className,
			};
		},
	},
	methods: {
		onClick( e ) {
			e.stopPropagation();
			this.$emit( "click" );
		},
	},
};
</script>

<style lang="scss" scoped>
.nav-sidebar-item {
	color: $gray-500;
	background-color: $mono-000;
	border-radius: 8px;
	padding: 4px 8px;

	font-style: normal;
	font-weight: 600;
	font-size: 14px;
	line-height: 20px;

	cursor: pointer;

	&--selected {
		color: $mono-000;
		background-color: $blue-500;
	}

	&:not(&--selected):hover {
		color: $blue-600;
		background-color: $blue-100;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar/NavSidebarItem.vue